import React from "react";
import "../styles/Account.css";

const Account = ( {userEmail} ) => {
  const handleResetPassword = () => {
    // Replace with your password reset logic
    alert(`Password reset link sent to ${userEmail}`);
  };

  return (
    <div className="account-container">
    <h2>Account</h2>
    <p>Manage your account details here.</p>
    
    <div className="account-details">
      <p><strong>Email:</strong> {userEmail}</p>
      <button className="reset-password-btn" onClick={handleResetPassword}>
        Reset Password
      </button>
    </div>
  </div>
  );
};

export default Account;